export default __webpack_public_path__ + "static/media/money-back@3x.e3da7f4d.png";